import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Drawer, Button } from 'antd';
import { TrophyOutlined, BarChartOutlined, LineChartOutlined, MenuOutlined, InfoCircleOutlined, SearchOutlined } from '@ant-design/icons';
import Main from './@page/Main';
import PlayerStats from './@page/PlayerStats';
import DayChart from './@page/DayChart';
import About from './@page/About';
import UserSearch from './@page/UserSearch';

const { Header, Content } = Layout;

function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // 監聽螢幕大小變化
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const menuItems = [
    {
      key: '/leaderboard',
      icon: <TrophyOutlined />,
      label: '每日排行榜',
    },
    {
      key: '/daily-chart',
      icon: <LineChartOutlined />,
      label: '單日變化',
    },
    {
      key: '/player-stats',
      icon: <BarChartOutlined />,
      label: '玩家統計',
    },
    {
      key: '/search',
      icon: <SearchOutlined />,
      label: '搜尋用戶',
    },
    {
      key: '/about',
      icon: <InfoCircleOutlined />,
      label: '關於',
    },
  ];

  const handleMenuClick = ({ key }) => {
    navigate(key);
    setDrawerVisible(false); // 點選後關閉 drawer
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{
        position: 'sticky',
        top: 0,
        zIndex: 1,
        width: '100%',
        padding: '0 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div style={{
          color: 'white',
          fontSize: '18px',
          fontWeight: 'bold',
          flex: 1,
        }}>
          光暈戰記系統
        </div>

        {/* 桌面版菜單 */}
        {!isMobile && (
          <Menu
            theme="dark"
            mode="horizontal"
            items={menuItems}
            selectedKeys={[location.pathname]}
            style={{
              border: 'none',
            }}
            onClick={handleMenuClick}
          />
        )}

        {/* 手機版菜單按鈕 */}
        {isMobile && (
          <Button
            type="text"
            icon={<MenuOutlined />}
            style={{
              color: 'white',
            }}
            onClick={() => setDrawerVisible(true)}
          />
        )}
      </Header>

      {/* 手機版側邊欄 */}
      <Drawer
        title="選單"
        placement="right"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        width={250}
      >
        <Menu
          mode="vertical"
          items={menuItems}
          selectedKeys={[location.pathname]}
          onClick={handleMenuClick}
        />
      </Drawer>
      <Content>
        <Routes>
          <Route path="/" element={<Navigate to="/leaderboard" replace />} />
          <Route path="/leaderboard" element={<Main />} />
          <Route path="/daily-chart" element={<DayChart />} />
          <Route path="/player-stats" element={<PlayerStats />} />
          <Route path="/search" element={<UserSearch />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<Navigate to="/leaderboard" replace />} />
        </Routes>
      </Content>
    </Layout>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
